import {
  CosmostationWalletIcon,
  IotaWalletIcon,
  NightlyWalletIcon,
} from 'modules/icons';

import { WalletId } from '../const';

const walletToIcon = {
  [WalletId.iota]: IotaWalletIcon,
  [WalletId.nightly]: NightlyWalletIcon,
  [WalletId.cosmostation]: CosmostationWalletIcon,
};

export function getWalletIconById(walletId: WalletId) {
  return walletToIcon[walletId];
}
